import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/documentosLegais';

class LegalService {
  static async getActiveDocuments() {
    const response = await api.get(BASE_PATH);
    return response.data;
  }

  static async getPendingDocuments() {
    const clientCode = sessionStorage.getItem('clientCode');
    const login = sessionStorage.getItem('login');
    const role = sessionStorage.getItem('role');

    if (!clientCode || !login || !role) return [];

    const response = await api.get(`${BASE_PATH}/pendentes`, {
      params: { clientCode, login, role }
    });
    return response.data;
  }

  static async acceptDocument(documentType, version) {
    const clientCode = sessionStorage.getItem('clientCode');
    const role = sessionStorage.getItem('role');

    const response = await api.post(
      `${BASE_PATH}/aceitar`,
      { documentType, version },
      { params: { clientCode, role } }
    );
    return response.data;
  }
}

export default LegalService;
